export const previewObject = {
  '.pdf': ({ src, ...rest }) => <iframe src={src} {...rest} />,
};

export const defaultPreview = ({ src, ...rest }) => <img src={src} alt='' {...rest} />;


export const previewImage = ({ ext, src, preview, ...rest }) => previewObject[ext] && previewObject[ext]({ src: preview || src, ...rest }) || defaultPreview({ src: preview || src, ...rest });